<template>
  <!--
    caso de uso Editar
      só consegue editar se o agendamento foi gravado no BD
        se não foi enviado os E-mails
          edita todos os campos
          não aparece modal de razões
        se foi enviado os E-mails (não contemplado espera de 1 hora antes de enviar os e-mails)
         aparece modal de razões
         não consegue editar a capacidade de atendimento
         ao alterar a data enviar um e-mail para o 'sindico'? sobre a mudança
         consegue mudar pedido
  -->
  <div>
    <v-layout row wrap :class="{'pa-4 condominium-box': true, 'editing': !scheduleEditing && value.id !== ''}">
      <template v-if="!scheduleEditing">
        <v-flex xs12>
          <strong>{{ value.condominium.name }}</strong>
        </v-flex>
        <v-flex xs12>
          <strong>Endereço:</strong> {{ value.condominium.address }}, {{ value.condominium.addressNumber }} - {{ value.condominium.neighborhood }}, {{ value.condominium.city }} - {{ value.condominium.state }}, {{ value.condominium.zipCode }}
        </v-flex>
        <v-flex xs12>
          <strong>Administradora:</strong> {{ value.condominium.administrator }}
        </v-flex>
        <v-flex xs12>
          <hr class="mt-2 mb-2">
        </v-flex>
      </template>
      
      <v-flex xs12>        
          <item-details :value="value"></item-details>
      </v-flex>     
      
      <v-flex xs4 pt-2>
        <strong>Seu pedido:</strong>        
      </v-flex>
      <v-flex xs4 pt-2>
        <strong>Data do agendamento:</strong>
      </v-flex>
      <v-flex xs4 pt-2>
        <strong>Capacidade de atendimento:</strong>
      </v-flex>
      <template v-if="!alteredScheduleSaving">
        <v-flex xs4 pt-2 pr-4>
          <v-text-field
            :value="value.code"
            @input="updateScheduleCode"
            :disabled="loadingNew || !scheduleEditing && value.id !== ''"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 pt-2 pr-4>
          <v-text-field
            v-if="loadingNew || !scheduleEditing && value.id !== ''"
            v-model="scheduleDateLabel"
            prepend-icon="event"
            :disabled="true"
            readonly
            ></v-text-field>        
            <v-text-field v-else
              slot="activator"
              v-model="scheduleDateLabel"            
              append-icon="add"
              :append-icon-cb="dataConfigOpen"
              :disabled="loadingNew"
              readonly
            ></v-text-field>            
        </v-flex>
        <v-flex xs4 pt-3 :class="{'interval-error': errorDisponibilityInterval}">
          <time-schedule></time-schedule>
        </v-flex>
      </template>      
      <DateConfig/>      
    </v-layout>      
    <div class="" v-if="value.id !== '' && value.status === 0">
      <v-layout row wrap class="condominium-box no-top-border text-xs-center mb-3 pa-1" v-if="value.status === 0 && !scheduleEditing">
        <v-flex v-if="!value.sent">
          <v-btn flat :disabled="loadingScheduleActions || alteredScheduleSaving" color="blue darken-3" @click.native="enableEdit"><v-icon class="mr-2">border_color</v-icon> Editar</v-btn>
        </v-flex>
        <v-flex v-else-if="value.sent">
          <v-btn flat disabled="disabled" color="blue darken-3"><v-icon class="mr-2">border_color</v-icon> Editar</v-btn>
        </v-flex>        
      </v-layout>
      <v-layout row wrap class="condominium-box no-top-border text-xs-center mb-5 pa-1" v-else>
        <v-flex>
          <v-btn flat :disabled="loadingScheduleActions" color="grey darken-1" @click.native="enableEdit">cancelar</v-btn>
        </v-flex>
        <v-flex v-if="!alteredSchedule">
          <v-btn flat color="blue" :disabled="true"><v-icon class="mr-2">check</v-icon>Confirma alterações</v-btn>
        </v-flex>
        <v-flex v-else>
          <v-btn flat color="green" :disabled="loadingScheduleActions" v-if="!alteredScheduleDateWarning" @click="alterSchedule"><v-icon class="mr-2">check</v-icon>Confirma alterações</v-btn>
          <alter-date-warning v-else>
            <v-btn flat color="green" :disabled="loadingScheduleActions"><v-icon class="mr-2">check</v-icon>Confirma alterações</v-btn>
          </alter-date-warning>
        </v-flex>
      </v-layout>
    </div>        
  </div>
</template>


<script>
import moment from 'moment'
import timeSchedule from './TimeSchedule'
import AlterDateWarning from '../AlterDateWarning'
import DateConfig from './DateConfig'
import itemDetails from './itemDetails'
export default {
  name: 'condominium-box',
  props: ['value'],
  components: {
    DateConfig,
    'time-schedule': timeSchedule,
    'alter-date-warning': AlterDateWarning,
    'item-details': itemDetails
  },
  data () {
    return {
      loadingNew: false,
      allowedDates: (date) => {
        return moment(date).diff(moment(), 'days') > -1
      }
    }
  },
  methods: {
    dataConfigOpen () {
      this.$store.commit('toggleDateConfigModal', true)
    },
    enableEdit () {
      this.$store.commit('toggleScheduleEditing')
      if (this.$store.getters.scheduleEditing) {
        for (let index = 0; index < this.value.itens.length; index++) {
          this.$store.commit('addItemForScheduled', this.value.itens[index])
        }
      } else {
        this.$store.commit('resetItemForScheduled')
      }
    },
    cancelChange () {
      this.$store.commit('cancelChange')
    },
    alterSchedule () {
      this.$store.commit('setSelectScheduleItens', this.$store.getters.selectedItens)
      this.$store.commit('resetItemForScheduled')
      this.$store.dispatch('alterSchedule')
    },
    sendEmailModal () {
      this.$store.dispatch('sendEmail')
    },
    finishSchedule () {
      this.$store.dispatch('finishSchedule')
    },
    saveSchedule () {
      if (this.$store.getters.disponibilityInterval) {
        this.$store.dispatch('setErrorDisponibilityInterval', false)
        this.$store.dispatch('saveSchedule')
      } else {
        this.$store.dispatch('setErrorDisponibilityInterval', true)
      }
    },
    newSearchCondominiumCnpj () {
      this.$store.commit('newSchedule')
    },
    searchCondominiumCnpj () {
      this.$store.dispatch('searchCondominiumCnpj')
    },
    updateScheduleCode (value) {
      this.$store.commit('updateScheduleCode', value)
    },
    updateScheduleDate (value) {
      this.$store.commit('updateScheduleDate', value)
    },
    updateSearchCnpj (value) {
      if (this.errorSearchCnpj) {
        this.$store.commit('errorSearchCnpj', false)
      }
      if (value.length < 14) {
        this.$store.commit('updateSearchCnpj', value)
      } else if (value.length === 14) {
        this.$store.commit('updateSearchCnpj', value)
        this.$store.dispatch('searchCondominiumCnpj')
      }
    }
  },
  computed: {
    scheduleEditing () {
      return this.$store.getters.scheduleEditing
    },
    alteredScheduleDateWarning () {
      return this.$store.getters.alteredScheduleDateWarning
    },
    scheduleDone () {
      return this.$store.getters.scheduleDone
    },
    loadingScheduleActions () {
      return this.$store.getters.loadingScheduleActions
    },
    errorSearchCnpj () {
      return this.$store.getters.errorSearchCnpj
    },
    disabled () {
      return this.loadingNew || this.schedule.status > 0
    },
    searchCnpj () {
      return this.$store.getters.searchCnpj
    },
    alteredScheduleSaving () {
      return this.$store.getters.alteredScheduleSaving
    },
    scheduleDatePicker () {
      return []
    },
    scheduleDateLabel () {
      if (this.schedule.dates !== null) {
        if (this.schedule.dates.length === 0) {
          return ''
        } else {
          if (this.schedule.dates.length > 1) {
            return 'Multiplas datas'
          } else {
            return moment(this.schedule.dates[0]).format('DD/MM/YYYY')
          }
        }
      }
    },
    loadingCondominium () {
      return this.$store.getters.loadingCondominium
    },
    schedule () {
      return this.$store.getters.selectedSchedule
    },
    alteredSchedule () {
      return this.$store.getters.alteredSchedule
    },
    scheduleDetailsModal: {
      get () {
        return this.$store.getters.scheduleDetailsModal
      },
      set () {
        this.$store.commit('toggleScheduleDetailsModal', false)
      }
    },
    errorDisponibilityInterval () {
      return this.$store.getters.errorDisponibilityInterval
    }
  }
}
</script>
<style>
.editing .input-group{
  border: 0px!important;
}
.condominium-wrapper{
  background-color: #f3f3f3;
  font-size: 16px;
}
.condominium-box{
  position: relative;
  border: 1px solid #e4e4e4;
  background-color: #fff;
}
.no-top-border{
  border-top: 0px!important;
}
.interval-error {
  border: 2px solid #e62039!important;
  border-radius: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// CondominiumBox.vue?3e1029a8